<template>
<header class="header">
  <div class="header_in">
  <h1 class="header_ttl">
    <router-link to="./"><img src="../assets/md_logo.svg" alt="MAZE DOLL" class="header_ttlImg"></router-link>
  </h1>
  <nav class="header_nav" :class="{'is-active': isActive}">
  <ul class="header_navList" >
    <li class="header_navItem"><router-link to="./" class="header_navLink"><span class="header_navLinkTxt" v-on:click="closeMenu">Top</span></router-link></li>
    <li class="header_navItem"><router-link to="./intro" class="header_navLink"><span class="header_navLinkTxt" v-on:click="closeMenu">Introduction</span></router-link></li>
    <li class="header_navItem"><router-link to="./character" class="header_navLink"><span class="header_navLinkTxt" v-on:click="closeMenu">Character</span></router-link></li>
    <li class="header_navItem"><router-link to="./special" class="header_navLink"><span class="header_navLinkTxt" v-on:click="closeMenu">Special</span></router-link></li>
    </ul>
<dl class="header_share">
        <dt class="header_shareTtl">Share</dt>
        <dd class="header_shareItem"><a href="https://twitter.com/intent/tweet?hashtags=AcuticNotes,MAZEDOLL&amp;text=MAZEDOLL%20PROJECT&amp;url=http%3a%2f%2facutic%2enet%2fACAL%2d0010%2f" class="header_shareLink"><img src="../assets/tw_logo.svg" alt="Twitter" class="header_twImg"></a></dd>
        <dd class="header_shareItem"><a href="http://www.facebook.com/share.php?u=http%3a%2f%2facutic%2enet%2fACAL%2d0010%2f" class="header_shareLink"><img src="../assets/fb_logo.svg" alt="Facebook" class="header_fbImg"></a></dd>
             <dd class="header_shareItem"><a href="https://social-plugins.line.me/lineit/share?url=http%3a%2f%2facutic%2enet%2fACAL%2d0010%2f" class="header_shareLink"><img src="../assets/line_logo.svg" alt="LINE" class="header_lineImg"></a></dd>

      </dl>
  </nav>
  <button class="header_btn" :class="{'is-active': isActive}" v-on:click="toggleMenu">
    <span class="header_btnTxt" v-if="!isActive">Menu</span>
    <span class="header_btnTxt" v-if="isActive">Close</span>
  </button>
  </div>
</header>
</template>
<script>

export default {
  data: () => {
    return {isActive: false}
  },
  methods: {
    toggleMenu () {
      this.isActive = !this.isActive
    },
    closeMenu(){
      this.isActive = false
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  position: relative;
  z-index: z(header);

  @include mq() {
    position: fixed;
    background-color: #fff;
    width: 100%;
  }

  &_in {
    padding: 36px;
    display: flex;
    font-size: 18px;
    justify-content: space-between;
    @include mq() {
      padding: 12px;
      display: block;
      position: relative;
    }
  }

  &_nav {

    //display: none;
    @include mq() {
      position: absolute;
      background-color: #fff;
      top: 66px;
      left: 0;
      width: 100vw;
      height: calc(100vh - 66px);
    }

    display: block;

  }

  &_btn {

    display: none;

    @include mq() {
      display: block;
      position: absolute;
      right: 12px;
      top: 12px;
    }

    &::before {
      content: '';
      display: inline-block;
      width: 28px;
      height: 28px;
      background: url(../assets/icon_menu.svg);
    }

    &.is-active::before {
      background: url(../assets/icon_close.svg);
    }
  }

  &_nav {
    display: flex;
    align-items: center;

    @include mq() {
      display: block;
    }

    @include mq() {
      display: none;

      &.is-active {
        display: block;
      }
    }
  }

  &_navList {

    list-style-type: none;

    @include mq() {
      padding-top: 24px;
    }
  }

  &_navItem {
    @include mq() {
      display: block;
    }

    text-align: center;
    display: inline-block;
    vertical-align: top;

  }

  &_navLink {
    display: block;
    padding: 16px;
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: .05em;
    cursor: pointer;
  font-family: 'DIN Next LT W01 Bold', 'Avenir', Helvetica, Arial, sans-serif;

    @include mq() {
      display: inline-block;
    }


  }

  &_navLinkTxt {

    position: relative;
    display: inline-block;
    padding: 2px 2px 2px 4px;
    line-height: 1;
    z-index: 1;
  }

  &_navLinkTxt::before {
    content: '';
    position: absolute;
    width: 0;
    height: 100%;
    z-index: -1;
    transition: all .2s ease;
    left: 0;
    top: 0;

  }
  
  &_navLink:hover &_navLinkTxt {
    color: #fff;

    &::before {
      background-color: #000;
      width: 100%;

    }
  }

  &_navLink.router-link-exact-active {
    cursor: default;
  }

  &_navLink.router-link-exact-active &_navLinkTxt {

    color: #000;
  }

  &_navLink.router-link-exact-active &_navLinkTxt::before {
    top: auto;
    bottom: -4px;
    width: 100%;
    height: 1px;
    background-color: #000;
  }

  &_navLink:not([href]) {
    color: #ccc;
    position: relative;
    padding: 16px 16px 4px;
    cursor: default;

    &::after {
      content: '';
      display: block;
      width: calc(100% - 16px);
      height: 1px;
      background-color: #ccc;
      position: absolute;
      bottom: 14px;
      left: 8px;
    }
  }

  &_navDesc {
    font-size: 14px;
    display: block;
    margin-top: -4px;
color: #707070;
  font-family: 'DIN Next LT W01 Regular', 'Avenir', Helvetica, Arial, sans-serif;

    &:lang(ja) {
      font-size: 12px;
    }
  }

  &_share {
    margin-left: 28px;
@include mq(lg){
  display: none;
}
    @include mq() {

      margin:100px auto;
    
      display: block;
      text-align: center;
    }
  }
 

&_shareTtl,
  &_shareItem {
    display: inline-block;
    margin-right: 16px;
    vertical-align: middle;

  }
   &_shareTtl{
    display: none;
    text-transform: uppercase;
    @include mq(){
display: inline-block;
     letter-spacing: .05em;
      text-align: center;
      
    }
  }

  &_shareLink {
    display: block;
    transition: all .2s ease;

    &:hover {
      opacity: .7;
    }
  }

  &_twImg,
  &_fbImg,
  &_lineImg {
    width: 20px;
    height: auto;
    display: block;
  }

  &_btnTxt {
    font-size: 8px;
    text-transform: uppercase;
    display: block;
    margin-top: -3px;
  }

  &_ttlImg {
    height: 48px;
    @include mq(lg){
      height: 32px;
      margin-top: 12px;
    }
    @include mq() {
      margin-top: 0;
      font-size: 24px;
          height: 28px;
    }
  }
}

</style>
